import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearExpireTime, showIdleModal } from "../store/auth/authSlice";

const IDLE_TIME = 10 * 60 * 1000;     // 3 min (test)
const WARNING_TIME = 2 * 60 * 1000; // 1 min (test)

export const useSessionManager = () => {
  const dispatch = useDispatch();
  const isModalOpen = useSelector(
    (s) => s.auth.showIdleModal
  );
  // ✅ Separate timers
  const idleTimer = useRef(null);
  const expiryTimer = useRef(null);

  const expireTime = useSelector(
    (s) => s.auth.expireTime
  );

  const isLogin = useSelector(
    (state) => !!state.auth.token
  );

  // -------- Idle Detection --------
  useEffect(() => {
    if (!isLogin) {
      clearTimeout(idleTimer.current);
      clearTimeout(expiryTimer.current);
      return;
    }

    let lastReset = 0;

    const reset = () => {
      const now = Date.now();

      if (now - lastReset < 1000) return;

      lastReset = now;

      clearTimeout(idleTimer.current);

      idleTimer.current = setTimeout(() => {
        if (!isModalOpen) {
          dispatch(showIdleModal("idle"));
        }
      }, IDLE_TIME);
    };

    const events = ["mousemove", "keydown", "scroll", "click"];

    events.forEach((e) =>
      window.addEventListener(e, reset)
    );

    reset();

    return () => {
      events.forEach((e) =>
        window.removeEventListener(e, reset)
      );

      clearTimeout(idleTimer.current);
      clearTimeout(expiryTimer.current);
    };
  }, [isLogin, dispatch]);

  // -------- Expiry Warning --------
  useEffect(() => {
    if (!isLogin || !expireTime) return;

    // ✅ Clear old expiry timer
    clearTimeout(expiryTimer.current);

    const expiryMs = new Date(expireTime).getTime();
    const now = Date.now();

    const warnAt = expiryMs - WARNING_TIME;
    const timeout = warnAt - now;

    if (timeout <= 0) {
      if (!isModalOpen) {
      dispatch(showIdleModal("expiry"));
      dispatch(clearExpireTime());
      }
      return;
    }

    expiryTimer.current = setTimeout(() => {
      if (!isModalOpen) {
      dispatch(showIdleModal("expiry"));
      dispatch(clearExpireTime());
      }
    }, timeout);

  }, [expireTime, isLogin, dispatch]);
};
